// extracted by mini-css-extract-plugin
module.exports = {"roundInfoWrapper":"SignupEplLanding_roundInfoWrapper_2tt00","scrollIcon":"SignupEplLanding_scrollIcon_1IKmf","scrollIconWrapper":"SignupEplLanding_scrollIconWrapper_3uG4d"};